export var FileSourceType;
(function (FileSourceType) {
    FileSourceType[FileSourceType["uploadMail"] = 0] = "uploadMail";
    FileSourceType[FileSourceType["downloadMail"] = 1] = "downloadMail";
    FileSourceType[FileSourceType["downloadIM"] = 2] = "downloadIM";
    FileSourceType[FileSourceType["downloadPreview"] = 3] = "downloadPreview";
})(FileSourceType || (FileSourceType = {}));
export const attachmentTypeMap = {
    'image/png': 'png',
    'image/apng': 'png',
    'image/avif': 'png',
    'image/gif': 'gif',
    'image/jpeg': 'jpeg',
    'image/svg+xml': 'svg',
    'image/webp': 'jpeg',
    'audio/aac': 'jpeg',
    'video/x-msvideo': 'avi',
    'text/csv': 'csv',
    'text/calendar': 'ics',
    'application/java-archive': 'jar',
    'application/x-tar': 'tar',
    'application/zip': 'zip',
    'application/vnd.ms-excel': 'xls',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
    'application/vnd.ms-powerpoint': 'ppt',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'pptx',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
    'application/vnd.visio': 'vsd',
    'application/rtf': 'rtf',
    'application/msword': 'doc',
    'application/pdf': 'pdf',
    'text/plain': 'txt',
    'video/mpeg': 'mpeg',
    'audio/mpeg': 'mp3',
    'audio/mpegurl': 'mp4',
    'application/gzip': 'gzip',
    'text/html': 'html',
    'text/css': 'css',
    'text/javascript': 'js',
    'application/json': 'json',
    'application/xml': 'xml',
    'text/xml': 'xml',
    'video/mp4': 'mp4',
    'application/x-apple-diskimage': 'dmg',
    'application/x-msi': 'msi',
    'application/x-msdos-program': 'exe',
    'image/x-photoshop': 'psd',
    'image/x-icon': 'ico',
    'application/rar': 'rar',
    'application/x-cm-encrypted': 'cmecypt',
};
